<!DOCTYPE html>
<html>
<head><title>Readiness</title></head>
<body>{{healthCheckMsg}}</body>
</html>